import { ComboType, GameSymbol } from './enums';

/** Punkte-Wert pro Symbol (Kleeblatt/Herz wenig, Stern am meisten) */
export const SYMBOL_VALUE: Record<GameSymbol, number> = {
  [GameSymbol.CLOVER]: 200,
  [GameSymbol.HEART]: 200,
  [GameSymbol.MOON]: 500,
  [GameSymbol.HORSESHOE]: 800,
  [GameSymbol.CROWN]: 1200,
  [GameSymbol.STAR]: 2000,
};

/** Maximale Spieleranzahl pro Raum */
export const MAX_PLAYERS = 10;

/** Anzahl großer Runden pro Match */
export const TOTAL_ROUNDS = 5;

/** Rundendauer in Millisekunden (90 Sekunden) */
export const ROUND_DURATION_MS = 90_000;

/** Draws pro Zug (werden nach Combo-Pick zurückgesetzt) */
export const DRAWS_PER_TURN = 2;

/** Anzahl der Walzen */
export const REEL_COUNT = 5;

/** Zeitfenster für Reconnect in Millisekunden */
export const RECONNECT_TIMEOUT_MS = 30_000;

/** Bonus-Punkte pro übrigem Draw */
export const DRAW_BONUS_POINTS = 500;

/** Basis-Bonus für das Abschließen aller Combos */
export const FINISH_BONUS_POINTS = 2000;

/** Maximaler Zeitbonus pro Combo */
export const MAX_TIME_BONUS = 1000;

/** Top-Leaderboard Einträge */
export const TOP_LEADERBOARD = 30;

/** Pause zwischen Runden in Millisekunden */
export const ROUND_PAUSE_MS = 5_000;

/** Basis-Punkte pro Combo-Typ */
export const BASE_POINTS: Record<ComboType, number> = {
  [ComboType.THREE_CLOVERS]: 2000,
  [ComboType.THREE_MOONS]: 2000,
  [ComboType.THREE_HEARTS]: 2000,
  [ComboType.THREE_STARS]: 2000,
  [ComboType.THREE_CROWNS]: 2000,
  [ComboType.THREE_HORSESHOES]: 2000,
  [ComboType.ONE_PAIR]: 1000,
  [ComboType.JOKER]: 1000,
  [ComboType.FULL_HOUSE]: 5000,
  [ComboType.FIVE_DIFFERENT]: 4000,
  [ComboType.FOUR_OF_A_KIND]: 8000,
  [ComboType.FIVE_OF_A_KIND]: 15000,
};
